import type { ReactNode } from "react";

type ToolsWorkbenchHeaderProps = {
  kicker: string;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
};

export function ToolsWorkbenchHeader({
  kicker,
  title,
  subtitle,
  actions,
}: ToolsWorkbenchHeaderProps) {
  return (
    <header className="marketplace__top">
      <div className="marketplace__title">
        <span>{kicker}</span>
        <h1>{title}</h1>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      {actions ? <div className="marketplace__top-actions">{actions}</div> : null}
    </header>
  );
}
